<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard heading="Asignacion de Empleados">
          <EmpleadosAsignadosLista></EmpleadosAsignadosLista>
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Asignacion',
  components: {
    EmpleadosAsignadosLista: () => import('../components/EmpleadosAsignadosLista')
  },
  data: () => ({
    page: {
      title: 'Comedor'
    },
    breadcrumbs: [
      {
        text: 'Asignación de Empleados',
        disabled: true
      },
      {
        text: 'Lista de Empleados Asignados',
        disabled: true
      }
    ]
  })
};
</script>
